import { IMember } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorIsCompany = (member: IMember) =>
  !!member.profile.company?.taxId;
